export const FETCHING_TWC_LIST = '@@toyota/FETCHING_TWC_LIST';
export const FETCHED_TWC_LIST = '@@toyota/FETCHED_TWC_LIST';
export const FETCHED_TWC_LIST_FAILED = '@@toyota/FETCHED_TWC_LIST_FAILED';
export const ADD_WARRANTY_CHECKED = '@@toyota/ADD_WARRANTY_CHECKED';
export const REMOVE_WARRANTY_CHECKED = '@@toyota/REMOVE_WARRANTY_CHECKED';
export const ADD_ALL_WARRANTY_CHECKED = '@@toyota/ADD_ALL_WARRANTY_CHECKED';
export const REMOVE_ALL_WARRANTY_CHECKED = '@@toyota/REMOVE_ALL_WARRANTY_CHECKED';
export const UPDATING_TWC_LIST = '@@toyota/UPDATING_TWC_LIST';
export const UPDATED_TWC_LIST = '@@toyota/UPDATED_TWC_LIST';
export const UPDATED_TWC_LIST_FAILED = '@@toyota/UPDATED_TWC_LIST_FAILED';
export const FETCHING_FILE_DATA = '@@toyota/FETCHING_FILE_DATA';
export const FETCHED_FILE_DATA = '@@toyota/FETCHED_FILE_DATA';
export const FETCHED_FILE_DATA_FAILED = '@@toyota/FETCHED_FILE_DATA_FAILED';
export const FETCHING_WARRANTY_SEQUENCES = '@@toyota/FETCHING_WARRANTY_SEQUENCES';
export const FETCHED_WARRANTY_SEQUENCES = '@@toyota/FETCHED_WARRANTY_SEQUENCES';
export const FETCHED_WARRANTY_SEQUENCES_FAILED = '@@toyota/FETCHED_WARRANTY_SEQUENCES_FAILED';
export const FETCHING_WARRANTY_STATUS = '@@toyota/FETCHING_WARRANTY_STATUS';
export const FETCHED_WARRANTY_STATUS = '@@toyota/FETCHED_WARRANTY_STATUS';
export const FETCHED_WARRANTY_STATUS_FAILED = '@@toyota/FETCHED_WARRANTY_STATUS_FAILED';
export const CLEAR_TWC_LIST = '@@toyota/CLEAR_TWC_LIST';
export const FETCHING_WARRANTY_REPORT_LIST = '@@toyota/FETCHING_WARRANTY_REPORT_LIST';
export const FETCHED_WARRANTY_REPORT_LIST = '@@toyota/FETCHED_WARRANTY_REPORT_LIST';
export const FETCHED_WARRANTY_REPORT_LIST_FAILED = '@@toyota/FETCHED_WARRANTY_REPORT_LIST_FAILED';
export const CLEAR_WARRANTY_REPORT_LIST = '@@toyota/CLEAR_WARRANTY_REPORT_LIST';
export const FETCHING_TASKS_LIST = '@@toyota/FETCHING_TASKS_LIST';
export const FETCHED_TASKS_LIST = '@@toyota/FETCHED_TASKS_LIST';
export const FETCHED_TASKS_LIST_FAILED = '@@toyota/FETCHED_TASKS_LIST_FAILED';
export const FETCHING_WARRANTY_REPORT = '@@toyota/FETCHING_WARRANTY_REPORT';
export const FETCHED_WARRANTY_REPORT = '@@toyota/FETCHED_WARRANTY_REPORT';
export const FETCHED_WARRANTY_REPORT_FAILED =
  '@@toyota/FETCHED_WARRANTY_REPORT_FAILED';
export const CLEAR_WARRANTY_REPORT = '@@toyota/CLEAR_WARRANTY_REPORT';

export const PROCESSING_WARRANTY_INVOICING_LIST = '@@toyota/PROCESSING_WARRANTY_INVOICING_LIST';
export const PROCESSED_WARRANTY_INVOICING_LIST = '@@toyota/PROCESSED_WARRANTY_INVOICING_LIST';
export const PROCESSED_WARRANTY_INVOICING_LIST_FAILED = '@@toyota/PROCESSED_WARRANTY_INVOICING_LIST_FAILED';
export const UPDATING_TWC_WARRANTY_INVOICING = '@@toyota/UPDATING_TWC_WARRANTY_INVOICING';
export const UPDATED_TWC_WARRANTY_INVOICING = '@@toyota/UPDATED_TWC_WARRANTY_INVOICING';
export const UPDATED_TWC_WARRANTY_INVOICING_FAILED = '@@toyota/UPDATED_TWC_WARRANTY_INVOICING_FAILED';
export const CLEAR_WARRANTY_INVOICING_LIST = '@@toyota/CLEAR_WARRANTY_INVOICING_LIST';

export const FETCHING_WARRANTY_ERROR_RATE_REPORT = '@@toyota/FETCHING_WARRANTY_ERROR_RATE_REPORT';
export const FETCHED_WARRANTY_ERROR_RATE_REPORT = '@@toyota/FETCHED_WARRANTY_ERROR_RATE_REPORT';
export const FETCHED_WARRANTY_ERROR_RATE_REPORT_FAILED = '@@toyota/FETCHED_WARRANTY_ERROR_RATE_REPORT_FAILED';
